import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
`;

export const ContainerUnico = styled.div`
    width: 95%;
    max-width: 1200px;
    margin: 20px auto 40px auto;
    padding: 20px;
    border: 2px solid #e74c3c;
    border-radius: 8px;
    background-color: #fff;
`;

export const Coluna = styled.div`
    flex: 1;
    min-width: 0;
`;

export const Form = styled.div`
    display: flex;
    gap: 30px;
    margin-top: 20px;
`;

export const Title = styled.h1`
    color: #333;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
`;

export const InputGroup = styled.div`
    margin-bottom: 15px;
`;

export const Label = styled.label`
    display: block;
    margin-bottom: 5px;
    color: #333;
    font-weight: 500;
`;

export const Input = styled.input`
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;

    &:focus {
        outline: none;
        border-color: #e74c3c;
    }
`;

export const Select = styled.select`
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;

    &:focus {
        outline: none;
        border-color: #e74c3c;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 20px;
`;

export const Button = styled.button`
    padding: 8px 16px;
    background-color: #e74c3c;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #c0392b;
    }
`;

export const BackButton = styled.button`
    display: flex;
    align-items: center;
    padding: 8px 16px;
    margin: 80px 0 0 20px;
    background-color: transparent;
    color: #e74c3c;
    border: 1px solid #e74c3c;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:hover {
        background-color: #e74c3c;
        color: white;
    }
`;

export const TableContainer = styled.div`
    margin-top: 20px;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;

    th, td {
        padding: 12px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    th {
        background-color: #f8f9fa;
        font-weight: 600;
    }

    tr:hover {
        background-color: #f5f5f5;
    }
`;

export const PreviewTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-weight: 500;
`;

export const PreviewContainer = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 20px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #666;
    }
`;

export const RefreshButton = styled.button`
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;

    &:hover {
        transform: rotate(180deg);
    }
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: rgba(231, 76, 60, 0.8);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: rgba(192, 57, 43, 1);
    }
`;
